import React from 'react';
import { Container } from 'react-bootstrap';

const ResponsiveIframe = () => {



    return (

        <Container fluid>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3750.2265558055947!2d73.7393117!3d19.956972300000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bddeb013af2e74b%3A0x9a08d210e90c37dd!2sPositive%20Metering%20Pumps%20India%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1727520484127!5m2!1sen!2sin" width="100%" height="300"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </Container>
    );
};

export default ResponsiveIframe;
